import {
  AUTHENTICATING_KLENTY_REQUEST, AUTHENTICATING_KLENTY_SUCCEDDED, AUTHENTICATING_KLENTY_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  activating: false,
  error: null
};

function klentyReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_KLENTY_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activating: true,
        error: null
      })
    
    case AUTHENTICATING_KLENTY_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activating: false,
        error: null
      })

    case AUTHENTICATING_KLENTY_FAILED:
      return Object.assign({}, state, {
        ...state,
        activating: false,
        error: action.payload
      })
    default:
      return state; 
  }
}

export { klentyReducer };